import { render, staticRenderFns } from "./box2-config-edit.vue?vue&type=template&id=6e600ede&scoped=true"
import script from "./box2-config-edit.vue?vue&type=script&lang=ts"
export * from "./box2-config-edit.vue?vue&type=script&lang=ts"
import style0 from "./box2-config-edit.vue?vue&type=style&index=0&id=6e600ede&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e600ede",
  null
  
)

export default component.exports